import * as React from 'react'

import { PreNavigationBanner } from '../../../Shared/index'

interface DemoAccountBannerProps {
  signedInOutsideDemo: boolean,
  recommendationsLink: string,
  growthSummaryLink: string,
  defaultIsExpanded?: boolean
}

const DemoAccountBanner = ({ signedInOutsideDemo, recommendationsLink, growthSummaryLink, defaultIsExpanded, }: DemoAccountBannerProps) => {
  const exitHref = signedInOutsideDemo ? "/teachers/unset_view_demo" : "/session"

  const expandedContent = (
    <ol className="pre-navigation-banner__list">
      <li><a className="focus-on-light" href={recommendationsLink}>Diagnostic Recommendations Report</a>: Identify areas of growth for your students and learn how to assign recommended practice activities.</li>
      <li><a className="focus-on-light" href="/teachers/classrooms/scorebook">Activity Summary</a>: See all of the completed activities for your students. Drill down to view what they wrote and the feedback they received.</li>
      <li><a className="focus-on-light" href={growthSummaryLink}>Growth Report</a>: Assign a post-test diagnostic to measure their learning gains. See the growth and learning gains for each student.</li>
    </ol>
  )

  return (
    <PreNavigationBanner
      button={{ text: 'Exit demo account', href: exitHref }}
      defaultExpanded={defaultIsExpanded}
      expandedContent={expandedContent}
      text="You’re in a demo account to explore sample student data."
      variant="standard"
    />
  )
}

export default DemoAccountBanner
